import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import store from './store'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(store)
  .component('VueDatePicker', VueDatePicker)
  .mount('#app')
